import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  activateDeactivateCrawlAPI,
  addCrawlAPI,
  deleteCrawlAPI,
  getCrawlAPI,
  getTableColumnNames,
  updateCrawlAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Crawl Table Column Names
export const fetchCrawlTableColumnNames = createAsyncThunk(
  "crawl/fetchCrawlTableColumnNames",
  async (crawl, thunkAPI) => {
    try {
      const response = await getTableColumnNames(crawl);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Crawl
export const fetchCrawl = createAsyncThunk(
  "crawl/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCrawlAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching crawl");
    }
  }
);

// Add Crawl
export const addCrawl = createAsyncThunk(
  "crawl/add",
  async (crawl, { rejectWithValue }) => {
    try {
      const response = await addCrawlAPI(crawl);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding crawl");
    }
  }
);

// Update Crawl
export const updateCrawl = createAsyncThunk(
  "crawl/update",
  async (crawl, { rejectWithValue }) => {
    try {
      const response = await updateCrawlAPI(crawl);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating crawl");
    }
  }
);

// Delete Crawl
export const deleteCrawl = createAsyncThunk(
  "crawl/delete",
  async (crawl, { rejectWithValue }) => {
    try {
      const response = await deleteCrawlAPI(crawl);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting crawl");
    }
  }
);

// Active Deactive Crawl
export const activateDeactivateCrawl = createAsyncThunk(
  "crawl/activateDeactivate",
  async (crawl, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateCrawlAPI(crawl);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating crawl");
    }
  }
);

